module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"manage":"Manage integrations","emptyDocumentLabel":"Send HelloSign document","manageIntegrations":{"title":"Navigate to your integrations list?","message":"A draft will be saved of your current automation.","confirm":"Manage integrations"},"error":"Please select a document"}}')
  delete Component.options._Ctor
}
